import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {MRTSConnectionEvent} from "./MRTSConnectionEvent.js";

/**
 * Retrieves the MRTS endpoint configured for MegaScreen for the current deployment ID.
 */
export class MRTSConnectionTask extends Task {
  constructor (mrtsConnection) {
    super();
    this.name = 'MRTS_CONNECTION';
    this.mrtsConnection = mrtsConnection;
    // The 'once' option automatically removes the event listener after the first time it runs
    this.mrtsConnection.on(MRTSConnectionEvent.CONTENT_READY, e => {
      this.done();
    }, { once: true });
  }

  start () {
    super.start();
    this.mrtsConnection.configureOrbiterConnections();
    this.mrtsConnection.connect();
  }
}